import { useT } from "@/lib/i18n/use-t";
import { T } from "./client-access-read-only-hint.i18n";

/** The read-only hint, for controls outside the access fields that share the same rule. */
export function ClientAccessReadOnlyHint() {
  const t = useT(T);
  return <p className="text-xs text-muted-foreground">{t.readOnly}</p>;
}
